import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Select, MenuItem, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        paddingBottom: "20px",
         marginLeft: "15px"
    }
}));

const UDFSelect = (props) => {
    const { UDF } = props;
    const classes = useStyles();

    const onChangeHandler = (event) => {
        props.changecontrolvalue(event, props.bookingID, UDF.UDFCategoryName, UDF.UDFID);
    }

    const GetUserMemberValue = () => {
        if (props.isMembership) {
            let userV = "";

            if (UDF.Users.filter(x => x.userID == props.usernumber).length > 0) {
                let user = UDF.Users.find(x => x.userID == props.usernumber);

                if (user && user.hasOwnProperty('userUDFValue')) {
                    userV = user.userUDFValue;
                }

                return userV;
            }
        }
        else {
            return UDF.Value;
        }
    }

    return (
        <div className={classes.root}>
            <Typography variant="subtitle1">{UDF.UdfDescription}</Typography>

            <Select
                fullWidth={true}
                labelId={UDF.UDFID.toString()}
                id={UDF.UDFID.toString()}
                name={UDF.UDFID.toString()}
                displayEmpty
                required={UDF.IsRequired}
                onChange={onChangeHandler}
                {...props}
                value={GetUserMemberValue()}
                sx={{ p: 4, '& .MuiInputLabel-root': { p: 4 } }}
                variant="standard"
            >
                {UDF.Picklist.map(picklist => (
                    <MenuItem key={picklist.UDFPicklistID} value={picklist.Option}>{picklist.Option}</MenuItem>
                ))}
            </Select>
            {/* </TextField> */}
        </div >
    );
};

UDFSelect.propTypes = {
    UDF: PropTypes.object.isRequired
};

export default UDFSelect;
